export default {"src":"/_next/static/media/Sales-Bill-Discounting.24d1c22e.svg","height":30,"width":26};